const colors = {
  black: '#000000',
  navy: '#212C54',
  ceil: '#509CEC',
  teal: '#46A2AC',
  grey: '#8B8B8B',
  maroon: '#880404',
  hunterGreen: '#187464',
  aubergine: '#481C54',
  powderBlue: '#CEEEFB',
  softBeige: '#F0E9D2',
  lavenderHaze: '#E1B6E9',
  yellow: '#F8D873',
  orange: '#FCAC4D',
  brown: '#A3603D',
  royalBlue: '#174CDE',
  picassoPink: '#F891A4',
  peach: '#F3A7A2',
  mauve: '#E5898E',
  khaki: '#556656',
  blue: '#005BD3',
  pink: '#FFC0CB',
  white: '#FFFFFF',
  fuchsia: '#D0348C',
  candyPink: '#E01474',
  powderPink: '#FFECEC',
  rougeRed: '#C0142C',
};

function toCamelCase(str) {
  return str
    .toLowerCase()
    .replace(/(?:^\w|\b\w|\s+)/g, (match, index) =>
      index === 0 ? match.toLowerCase() : match.toUpperCase()
    )
    .replace(/\s+/g, '');
}

/* DESKTOP NAV */
document.querySelectorAll('.f-site-nav__sub-link span').forEach(span => {
  const text = span.textContent.trim();
  const key = toCamelCase(text);

  if (!colors[key]) return;
  if (span.querySelector('em')) return;

  const em = document.createElement('em');
  em.style.backgroundColor = colors[key];

  span.prepend(em);
});

/* MOBILE NAV */
document.querySelectorAll('.f-mobile-nav__sub-link').forEach(link => {
  const text = link.textContent.trim();
  const key = toCamelCase(text);

  if (!colors[key]) return;
  if (link.querySelector('em')) return;

  const em = document.createElement('em');
  em.style.backgroundColor = colors[key];

  link.prepend(em);
});